import React, { useCallback } from 'react';
import { Form as AntForm } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isUndefined } from 'lodash';
import Form from '../../../../antd/form/Form/Form';
import FormButtonsContainer from '../../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import { CollapseBlock } from '../../../../common';
import { required } from '../../../../antd/form/FormValidation';
import FormButton from '../../../../antd/form/FormButton/FormButton';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField';
import FormTextArea from '../../../../antd/form/FormTextArea/FormTextArea';
import FormHiddenField from '../../../../antd/form/FormHiddenField/FormHiddenField';
import { SensorAttributeFields } from '../components/SensorAttributeFields';
import { isAttributeKeyDefault } from '../../../../../utils/helpers/CommonHelper';

export function SensorForm({ initials, units, onSubmit }) {
  const { t } = useTranslation();

  const [form] = AntForm.useForm();

  const handleAttributesValidation = useCallback((_, attributes) => {
    if (isUndefined(attributes) || (attributes?.length || 0) === 0) {
      return;
    }

    const orderHashTable = {};

    const hasDuplicates = attributes.some((attribute) => {
      if (attribute.order === 0) {
        return false;
      }

      // if there is no order value in keys of orderHashTable object
      // set key and return false
      if (isUndefined(orderHashTable[attribute.order])) {
        orderHashTable[attribute.order] = true;
        return false;
      }

      // Order value found in in keys of orderHashTable object,
      // return true, that indicates, that array has duplicates
      return true;
    });

    return !hasDuplicates
      ? Promise.resolve()
      : Promise.reject('Duplicitné hodnoty poradia');
  }, []);

  return (
    <>
      <Form initialValues={initials} onFinish={onSubmit} form={form}>
        <h2 className="meteo-station-edit-section-title">{t('Senzor')}</h2>

        <CollapseBlock title={t('Všeobecné informácie')} collapsible>
          <FormTextField
            label={t('Názov senzora')}
            name={'name'}
            rules={[required(t)]}
          />
          <FormTextArea
            label={t('Popis')}
            name={'description'}
            rules={[required(t)]}
            autoSize={{ minRows: 5, maxRows: 12 }}
          />
        </CollapseBlock>

        <h2 className="meteo-station-edit-section-title">
          {t('Atribúty senzora')}
        </h2>

        <AntForm.List
          name={'sensor_attributes'}
          rules={[
            required(t),
            {
              validator: handleAttributesValidation,
            },
          ]}
        >
          {(fields, operations, { errors }) => (
            <>
              {fields.map(({ key, name }) => (
                <CollapseBlock
                  title={form.getFieldValue([
                    'sensor_attributes',
                    key,
                    'label',
                  ])}
                  collapsible
                  key={key}
                >
                  <FormHiddenField name={[name, 'id']} rules={[required(t)]} />

                  <SensorAttributeFields
                    units={units}
                    isIconDisabled={isAttributeKeyDefault(
                      form.getFieldValue(['sensor_attributes', key, 'key']),
                    )}
                    parentName={[name]}
                  />
                </CollapseBlock>
              ))}
              <AntForm.Item>
                <AntForm.ErrorList errors={errors} />
              </AntForm.Item>
            </>
          )}
        </AntForm.List>

        <FormButtonsContainer>
          <FormButton submitOnClick={true}>{t('Uložiť')}</FormButton>
        </FormButtonsContainer>
      </Form>
    </>
  );
}

SensorForm.propTypes = {
  initials: PropTypes.object.isRequired,
  units: PropTypes.array.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
